import { Routes } from '@angular/router';
import { PublicLayoutComponent } from './layout/public-layout/public-layout.component';
import { PageNotFoundComponent } from './layout/page-not-found/page-not-found.component';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layout/main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent
      ),
    title: '',
    children: [
      {
        path: 'applications',
        title: 'NTO | Prijave',
        loadChildren: () =>
          import('./feature/applications/applications.routes'),
      },
      {
        path: 'schedule',
        title: 'NTO | Raspored',
        loadChildren: () => import('./feature/schedule/schedule.routes'),
      },
      {
        path: 'settings',
        title: 'NTO | Podešavanja',
        loadChildren: () => import('./feature/settings/settings.routes'),
      },
      {
        path: 'dashboard',
        title: 'Nature Travel Office',
        loadChildren: () => import('./feature/dashboard/dashboard.routes'),
      },
      {
        path: 'users',
        title: 'NTO | Korisnici',
        loadChildren: () => import('./feature/users/users.routes'),
      },
      {
        path: '',
        redirectTo: 'schedule',
        pathMatch: 'full',
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'public',
    title: 'Nature Travel Office',
    component: PublicLayoutComponent,
    loadChildren: () => import('./feature/auth/auth.routes'),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    title: 'NTO | Prijavi se',
    loadComponent: () =>
      import('./feature/auth/pages/login/login.component').then(
        (m) => m.LoginComponent
      ),
  },
  { path: '**', component: PageNotFoundComponent },
];
